export const isSafari = (ua: string) => ua.includes('Safari') && !ua.includes('Chrome');
